import styles from "components/event/EventDetailComponentBrand.module.scss";
import Link from "next/link";
import {getBrandRoute, getProductRouteFromProduct} from "common/const";
import {LazyImage} from "components/sections/product/ProductInfoSection";
import {useRef} from "react";
import {useDraggable} from "react-use-draggable-scroll";
import Image from "next/image";
import RollingImage from "../images/RollingImage";


const BrandProductListSection = ({brand}) => {
    const horizontalDraggableRef = useRef();
    const {events} = useDraggable(horizontalDraggableRef);

    const brandProducts = brand.simple_products.slice(0, 4);

    return (
        <div className={styles.brandProductListSection} ref={horizontalDraggableRef} {...events}>
            {
                brandProducts && brandProducts.length > 0 &&
                brandProducts.map(product => {
                    return (
                        <div className={styles.productCardWrapper} key={product.id}>
                            <Link href={getProductRouteFromProduct(product)}>
                                <div className={styles.productCardImageWrapper}>
                                    {
                                        (product.thumbnail_url_list && product.thumbnail_url_list.length > 0) ?
                                            <RollingImage prefix={"images"} images={product.thumbnail_url_list}/>
                                            :
                                            <Image
                                                layout="fill"
                                                unoptimized
                                                objectFit="cover"
                                                src={product.thumbnail_url}
                                            />
                                    }
                                </div>
                            </Link>
                        </div>
                    );
                })
            }
        </div>
    );
};

const EventDetailComponentBrand = (props) => {
    const {component, brand, onClick, rank} = props;

    const getBrandDescription = () => {
        return component.description ? component.description : brand.description;
    }

    return (
        <div className={styles[`theme-${component?.theme}`]}>
            <div key={brand.id} className={styles.brandWrapper}>
                <Link href={getBrandRoute(brand.id)} key={brand.id}>
                    <a onClick={() => onClick(brand)}>
                        <div className={styles.brandCardInfoSection}>
                            <div className={styles.brandCardThumbnailWrapper}>
                                {
                                    (brand.logo_image_with_background_url || brand.logo_image_url) &&
                                    <LazyImage
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                            objectPosition: 'center',
                                            borderRadius: 9999,
                                        }}
                                        src={brand.logo_image_with_background_url || brand.logo_image_url}
                                    />
                                }
                            </div>
                            <div className={styles.brandCardNameWrapper}>
                                <div className={styles.brandNameWrapper}>
                                    {brand.name && <span className={styles.brandName}>{brand.name}</span>}
                                    {component.attrs.tags && component.attrs.tags.map(tag => {
                                        return (
                                            <span key={`tag-${tag}`} className={styles.tag}>#{tag}</span>
                                        );
                                    })}
                                </div>
                                <div className={styles.brandDescriptionWrapper}>
                                    {getBrandDescription()}
                                </div>
                            </div>
                            <div className={styles.rankWrapper}>
                                {rank && <span className={styles.rank}>{rank}위</span>}
                            </div>
                        </div>
                    </a>
                </Link>
                <BrandProductListSection brand={brand}/>
            </div>
        </div>
    )
};

export default EventDetailComponentBrand;
